import * as z from 'zod/v4';

export const tipsinfoEnum = z.enum(['Odds', 'StartOdds', 'SvenskaFolket', 'Matchstart', 'FavoriteOdds', 'Mutuals']);

/**
 * Available Tipsinfo types in coupon
 */
export const tipsinfoExtendedEnum = z.enum([...tipsinfoEnum.options, 'Analysis']);

export type Tipsinfo = z.infer<typeof tipsinfoExtendedEnum>;
